<template>
  <div class="empty-data">
    <img class="icon" :src="icon" alt="无" />
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: require("@/assets/images/emtpy_data.png"),
    },
    text: {
      type: String,
      default: "暂无数据",
    },
  },
};
</script>

<style lang="less" scoped>
.empty-data {
  width: 100px;
  position:fixed;
  top:45%;
  left:50%;
  transform: translate(-50%,-45%);
}
.icon {
  display: block;
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.text {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  text-align: center;
}
</style>